import React, { useEffect, useState } from "react";
// import tw from "twin.macro";
// import styled from "styled-components";

import Chit from "../components/Chit.js";
import { getCustomerId } from "../utility/HeaderConfig";
import { Link } from "react-router-dom";
import { getCustomer } from "api/CustomerApi";
import MyProfile from "./MyProfile.js";
import { schemeStatus } from "api/MySchemeApi.js";

const value = [
  {
    icon1: "bi bi-check-circle",
    icon: "bi bi-check-circle icon-bg",
    name: "Active",
    count: "2",
    click: "Active",
  },
  {
    icon1: "bi bi-hourglass-top",
    icon: "bi bi-hourglass-top icon-bg",
    name: "Pending",
    count: "3",
    click: "Waiting_For_Approval",
  },
  {
    icon1: "bi bi-door-closed ",
    icon: "bi bi-door-closed icon-bg",
    name: "Close",
    count: "1",
    click: "Completed",
  },
  {
    icon1: "bi bi-x-circle icon-bg",
    icon: "bi bi-x-circle icon-bg",
    name: "Cancelled",
    count: "6",
    click: "Cancelled",
  },
];

// const TabControl = styled.div`
//   ${tw`bg-custom-green rounded p-6  cursor-pointer`}
//   &:hover {
//     ${tw`bg-custom-100 text-white`}
//   }
//   ${(props) => props.active && tw`bg-custom-100! text-gray-100!`}
//   }
// `;

// const Heading = tw.h1`text-center`;

export default () => {
  const [Details, setDetails] = useState({});
  const [Status, setStatus] = useState("Active");
  const [chitList, setChitList] = useState([]);

  useEffect(() => {
    getCustomerDetails();
  }, []);

  const getCustomerDetails = () => {
    const response = getCustomer(getCustomerId());
    response.then((data) => {
      setDetails({
        name: data.response.name,
        mobile: data.response.mobile,
        email: data.response.email,
        address1:
          data.response.customerAddress != null
            ? data.response.customerAddress.address1
            : "",
        branchName:
          data.response.branchName != null ? data.response.branchName : "-",
        branchId: data.response.branchId,
        customerId: data.response.id,
        countryName:
          data.response.countryName !== undefined
            ? data.response.countryName
            : null,
        stateName:
          data.response.stateName !== undefined
            ? data.response.stateName
            : null,
        pincodeNumber:
          data.response.pincodeNumber !== undefined
            ? data.response.pincodeNumber
            : null,
        districtName:
          data.response.districtName !== undefined
            ? data.response.districtName
            : null,
      });
    });
  };

const getChitList = () => {
  const filters = {
    status: Status,
    branchDetailsEntity: Details.branchId,
    customerEntity: Details.customerId,
  };

  schemeStatus(filters).then((res) => {
    setChitList(res.response.content || []);
  });
};

useEffect(() => {
  if (Details.customerId && Details.branchId) {
    getChitList();
  }
  //eslint-disable-next-line
}, [Status, Details]);

const getCount = () => chitList.length;

  return (
    <div className="row m-0 position-relative">
      <MyProfile Details={Details} />
      <div className="col-lg-12 col-xl-9 py-4 px-0" tw="bg-gray-100">
        <div className="container-fluid ">
          <h4 tw="font-dancing" style={{ color: "#6b5330" }}>
            Dashboard
          </h4>
          <div className="ptSans" tw="text-sm">
            <Link
              to="/"
              tw="ml-3 no-underline text-black"
              style={{
                color: "var(--gold-300)",
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              Home
            </Link>
            {" > "}
            <span
              tw="ml-3"
              style={{
                color: "var(--gold-400)",
                fontWeight: 500,
                textTransform: "capitalize",
              }}
            >
              MyScheme
            </span>
            {" > "}
            <span
              tw="ml-3 text-custom-100"
              style={{
                color: "var(--gold-500)",
                fontWeight: 500,
                textTransform: "capitalize",
              }}
            >
              Dashboard
            </span>
          </div>

          <div className="row g-3 mt-3">
            {value.map((data, idx) => (
              <div key={idx} className="col-12 col-sm-6 col-lg-3">
                <div
                  className={`dashboard-card ${Status === data.click ? "active" : ""}`}
                  onClick={() => setStatus(data.click)}
                >
                  <div className="card-icon">
                    <i className={data.icon1}></i>
                  </div>

                  <div className="card-content">
                    <h5 style={{ color: "#6b5330" }}>{data.name}</h5>
                    <p style={{ color: Status === data.click ? "#a06b1d" : ''}}>{Status === data.click ? getCount() : "0"} Items</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Chit chitStatus={Status} Details={Details} />
      </div>
    </div>
  );
};